import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const testimonials = [
  {
    name: 'Mr. Arjun Nair',
    position: 'IT Professional',
    content:
      '“ Booking a cab during peak hours used to be a nightmare until I found Prince Cabs. Their app is smooth, and the service is top-notch. Highly dependable!”',
  },
  {
    name: 'Mrs. Kavita Deshmukh',
    position: 'Working Mom',
    content:
      '“ With two kids and a busy job, I rely on Prince Cabs for safe and timely school pickups and daily travel. Their drivers are courteous and trustworthy.”',
  },
  {
    name: 'Mr. Faizan Ali',
    position: 'Airport Commuter',
    content:
      '“ I fly frequently, and Prince Cabs has become my go-to for early morning and late-night airport runs. Always on time and very professional.”',
  },
];

const sliderSettings = {
  dots: true,
  arrows: false,
  infinite: true,
  speed: 700,
  autoplay: true,
  autoplaySpeed: 5000,
  slidesToShow: 1,
  slidesToScroll: 1,
};

const AboutTestimonialSection = () => {
  return (
    <div
      className="testimonial-section"
      style={{
        backgroundImage: 'url(/images/img23.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="container">
        <div className="row">
          <div className="col-lg-10 offset-lg-1">
            <div className="testimonial-inner">
              <Slider {...sliderSettings}>
                {testimonials.map((testimonial, index) => (
                  <div className="testimonial-item text-center" key={index}>
                    {/* Star rating - 5 stars */}
                    <div className="testimonial-stars" style={{ fontSize: '24px', color: '#FFD700', marginBottom: '15px' }}>
                      ★★★★★
                    </div>
                    <div className="testimonial-content">
                      <p>{testimonial.content}</p>
                      <cite>
                        {testimonial.name}
                        <span className="company"> — {testimonial.position}</span>
                      </cite>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutTestimonialSection;
